const findCommonPaymentConstraints = ({ model, tickets }) => {
    let constrainedInstrumentType = null;
    let constrainedPaymentMethods = null;

    if (Array.isArray(tickets) && tickets.length) {
        constrainedPaymentMethods = tickets.reduce(
            (commonPaymentMethods, ticket) => {
                const {
                    instrument_type: instrumentType,
                    payment_methods: paymentMethods,
                } = ticket;
                let commonPaymentMethodsToUse = commonPaymentMethods;

                if (!constrainedInstrumentType) {
                    constrainedInstrumentType = instrumentType;
                }

                if (
                    !Array.isArray(commonPaymentMethodsToUse) ||
                    !commonPaymentMethodsToUse.length
                ) {
                    commonPaymentMethodsToUse = paymentMethods;
                } else if (
                    Array.isArray(paymentMethods) &&
                    paymentMethods.length
                ) {
                    commonPaymentMethodsToUse =
                        commonPaymentMethodsToUse.filter((constarint) =>
                            paymentMethods.includes(constarint),
                        );
                }

                return commonPaymentMethodsToUse;
            },
            [],
        );

        if (constrainedInstrumentType && !constrainedPaymentMethods) {
            constrainedPaymentMethods = [constrainedInstrumentType];
        }
    }

    model.set('globals.constrainedInstrumentType', constrainedInstrumentType);
    model.set('globals.constrainedPaymentMethods', constrainedPaymentMethods);
};

const checkTicketsForConflictingPayment = ({ model }) => {
    const constrainedInstrumentType = model.get(
        'globals.constrainedInstrumentType',
    );
    const constrainedPaymentMethods = model.get(
        'globals.constrainedPaymentMethods',
    );
    const ticketClassesNode = model.get('globals.ticketClasses');

    if (ticketClassesNode) {
        Object.keys(ticketClassesNode).forEach((ticketClassIndex) => {
            const ticketPaymentConstraints = model.get(
                `globals.ticketClasses.${ticketClassIndex}.payment_constraints`,
            );
            const hasPaymentConstraints =
                Array.isArray(ticketPaymentConstraints) &&
                !!ticketPaymentConstraints.length;

            const hasConflict = !hasPaymentConstraints
                ? false
                : Array.isArray(constrainedPaymentMethods) &&
                  !ticketPaymentConstraints.some(
                      ({
                          instrument_type: instrumentType,
                          payment_method: paymentMethod,
                      }) =>
                          instrumentType === constrainedInstrumentType &&
                          constrainedPaymentMethods.includes(
                              paymentMethod || instrumentType,
                          ),
                  );

            model.set(
                `globals.ticketClasses.${ticketClassIndex}.conflictingPayment`,
                hasConflict,
            );
        });
    }
};

export default {
    findCommonPaymentConstraints,
    checkTicketsForConflictingPayment,
};
